/**
 * The name a document is shown by (#6559 round 19e, Hunter): its stored name
 * without an extension the system made up — an interaction (`.fp`,
 * `.altvia`), an ingested email (`.email`; `.msg` and `.eml` are real), a
 * Teams post, a OneNote page, an eVestment note, an empty placeholder. One
 * rule for every surface that names a document: the Documents page, the
 * picker's selection, the viewer's header, a delete prompt.
 */
const INTERNAL_EXTENSIONS =
  /\.(fp|altvia|email|post|onenote|evestment|empty)$/i;

export const displayFileName = (fileName: string): string =>
  fileName.replace(INTERNAL_EXTENSIONS, "");
